import { render, staticRenderFns } from "./UserCardBin.vue?vue&type=template&id=cc9366b6&scoped=true&"
import script from "./UserCardBin.vue?vue&type=script&lang=js&"
export * from "./UserCardBin.vue?vue&type=script&lang=js&"
import style0 from "./UserCardBin.vue?vue&type=style&index=0&id=cc9366b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9366b6",
  null
  
)

export default component.exports